import React from "react";
import azState from "../../../../assets/az_state.png";
import stackBar from "../../../../assets/stacked_bar_chart.png";

export const charts = [
  {
    id: "title_map",
    icon: azState,
    name: "Tribes with Colorado River entitlements in Central Arizona",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "Tribes: Title Map",
    subtitle: "",
    floating_title: true,
    metrics: [],
  },
  {
    id: "tribal_shortage_impacts",
    icon: stackBar,
    name: "Tribal Shortage Impacts",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "Tribal Shortage Impacts (acre-feet)",
    subtitle: "",
    floating_title: false,
    metrics: [
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
      { label: "Metric Name", value: "Xx,xxx ac-ft" },
    ],
  },
];

export const about = [
  {
    title: "Summary",
    desc: (
      <p style={{ fontSize: "16" }}>
        This map shows the tribes in Central Arizona with a Colorado River
        entitlement. The stats indicate the quantity of the Colorado River
        entitlements each tribe holds (by priority) minus the quantity leased or
        exchanged to others. The remainder is the tribe’s total access to the
        water. For a primer on Colorado River water priorities in Central
        Arizona,{" "}
        <a
          target="_blank"
          href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/"
          rel="noopener noreferrer"
        >
          click here
        </a>
        .{" "}
      </p>
    ),
  },
  {
    title: "Summary",
    desc: (
      <p style={{ fontSize: "16" }}>
        Using the slider at the top, a user can see the quantity of Colorado
        River water available at each shortage tier and under more severe
        scenarios. On the chart, the amount of Colorado River water available to
        each tribe under different shortage scenarios is contrasted with the
        tribe’s entitlement to Colorado River water by priority. For a primer on
        Colorado River water priorities in Central Arizona,{" "}
        <a
          target="_blank"
          href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/"
          rel="noopener noreferrer"
        >
          click here
        </a>
        .
      </p>
    ),
  },
];

export const tribes = [
  { label: "Subject", value: 0 },
  { label: "Subject", value: 1 },
  { label: "Subject", value: 2 },
  { label: "Subject", value: 3 },
];
